import pick from 'lodash/pick'
import template from 'lodash/template'
import D2C_Service from '../Service'
import store from '@/store'

class D2C_ServiceWeb extends D2C_Service {
  isWeb = true
  static objectType = 'serviceRole'
  static groupTitle = 'Other'
  static roleName = 'web'
  static roleTitle = 'Web'
  getServiceConfigMode(service) {
    const {serviceConfigModes} = this.constructor.fields.services
    let mode = serviceConfigModes[0].value
    if (mode === 'proxy' && service.type === 'php') {
      mode = 'fastcgi'
    }
    if (mode === 'http' && !service.isApp && !service.isWeb) {
      mode = 'tcp'
    }
    return mode
  }
  getServiceConfigText(service, mode) {
    const {serviceConfig} = this.constructor.fields.services
    mode = mode || this.getServiceConfigMode(service)
    return template(serviceConfig || '')({service, mode})
  }
  getServiceConfig(service, mode) {
    const {account, config} = store.state
    const {serviceConfigFields, serviceConfigSuffix} = this.constructor.fields.services
    const {id, name, type} = service
    const newFields = {
      cert: '',
      config: this.getServiceConfigText(service, mode),
      domains: [`${name.toLowerCase()}${serviceConfigSuffix}.${account.shortId}.at.${config.domain}`],
      https: 'none',
      id,
      key: '',
      name,
      secure: 'high',
      static: type === 'php',
      sticky: false,
    }
    return pick(newFields, serviceConfigFields)
  }
}

export default D2C_ServiceWeb
